import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Button, Drawer, Form, Input, Select, Spin, TimePicker } from "antd";
import PropTypes from "prop-types";
import moment from "moment-jalaali";
import { DatePicker, useJalaliLocaleListener } from "antd-jalali";
// import dayjs from "dayjs";

import { Modals, Types } from "scripts/settings";
import API from "scripts/api";
import Resources from "scripts/resources";
import Rules from "scripts/rules";

import InputCurrency from "components/InputCurrency";
import UploadImage from "components/UploadImage";
import TextEditor from "components/TextEditor";

const Component = ({
	data = {},
	onUpdate,
	options: { courses = [], images = [], files = [] },
}) => {
	const initialState = { editTime: false, chosenImage: "" };
	const [state, setState] = useState(initialState);
	const { editTime, submitting, visible, chosenImage, loading } = state;
	const { id, title } = data;
	const { hash, pathname, search } = useLocation();
	const navigate = useNavigate();
	const [form] = Form.useForm();

	const handleSubmit = () => {
		if (!submitting) {
			form.validateFields().then((values) => {
				setState((prevState) => ({ ...prevState, submitting: true }));

				if (values.description) {
					values.description = values.description.replaceAll(
						/<\/p><p>/g,
						"<br />"
					);
					values.description = values.description.replaceAll("<br>", "");
					values.description = values.description.replaceAll(
						/<\/p><p\s+class="[^"]*">/g,
						"<br />"
					);
				}

				const newCourseValues = values.courses.map((item) => {
					return item.value ? item.value : item;
				});

				values.courses = newCourseValues;

				const action =
					hash === `#${Modals.CREATE}`
						? API.package.create(values)
						: API.package.update(id, values);

				action
					.then(() => {
						onUpdate(null, true);
						navigate(-1);
					})
					.finally(() => {
						setState((prevState) => ({ ...prevState, submitting: false }));
					});
			});
		}
	};

	useJalaliLocaleListener();
	const componentDidUpdate = () => {
		switch (hash) {
			case `#${Modals.CREATE}`: {
				setState((prevState) => ({ ...prevState, visible: true }));

				break;
			}
			case `#${Modals.EDIT}`: {
				if (id) {
					setState((prevState) => ({
						...prevState,
						loading: true,
						visible: true,
						chosenImage: data?.cover?.url,
					}));
					API.package.details(data.id).then(({ data: _data }) => {
						setState((prevState) => ({
							...prevState,
							loading: false,
							chosenImage: _data?.cover?.url,
						}));
						form.setFieldsValue({
							..._data,
							...data,
							discountExpiresAt:
								_data?.discountExpiresAt &&
								moment(_data?.discountExpiresAt).format(
									process.env.REACT_APP_DATE_TIME_FORMAT_JALALI
								),
							coverId: _data?.cover?.id,
							categoryId: _data?.category?.id,
							files: _data?.files?.map(({ title, id }) => ({
								label: title,
								value: id,
							})),
						});
					});
				} else {
					navigate({ pathname, search }, { replace: true });
				}

				break;
			}
			default: {
				if (visible) form.resetFields();

				setState(initialState);

				break;
			}
		}
	};

	useEffect(componentDidUpdate, [hash]);

	return (
		<Drawer
			className="sp-form-drawer"
			placement={process.env.REACT_APP_IS_RTL ? "left" : "right"}
			footer={
				<>
					<Button
						type="primary"
						onClick={handleSubmit}
						loading={submitting}
					>
						{Resources.confirm}
					</Button>
					<Button
						onClick={() => navigate(-1)}
						disabled={submitting}
					>
						{Resources.cancel}
					</Button>
				</>
			}
			onClose={() => navigate(-1)}
			title={
				hash === `#${Modals.CREATE}`
					? `${Resources.add} ${Resources.package}`
					: `${Resources.edit} ${Resources.package} "${title}"`
			}
			maskClosable={false}
			open={visible}
			width={768}
		>
			{!loading ? (
				<Form
					layout="vertical"
					form={form}
				>
					<>
						<Form.Item
							name="title"
							label={Resources.title}
							rules={Rules.required}
						>
							<Input />
						</Form.Item>
						<Form.Item
							name="courses"
							label={Resources.course}
							rules={Rules.required}
						>
							<Select
								options={courses}
								allowClear
								mode="multiple"
							/>
						</Form.Item>
						<Form.Item
							name="price"
							label={Resources.price}
							rules={Rules.required}
						>
							<InputCurrency />
						</Form.Item>
						<Form.Item
							name="summary"
							label={Resources.summary}
							rules={Rules.required}
						>
							<Input.TextArea rows={2} />
						</Form.Item>

						<Form.Item
							name="description"
							label={Resources.description}
							rules={Rules.required}
						>
							<TextEditor />
						</Form.Item>

						<Form.Item
							name="files"
							label={`${Resources.file}${Resources.ha}`}
						>
							<Select
								options={files}
								mode="multiple"
							/>
						</Form.Item>

						<Form.Item
							name="coverId"
							label={Resources.image}
							rules={Rules.required}
						>
							<Select
								options={images}
								optionFilterProp="label"
								onChange={(e, element) => {
									setState((prev) => ({ ...prev, chosenImage: element.file }));
								}}
								showSearch
							/>
						</Form.Item>
						{chosenImage ? (
							<img
								src={chosenImage}
								className="image"
								style={{
									width: "50%",
									objectFit: "cover",
									margin: "0 auto",
									display: "block",
								}}
							/>
						) : (
							""
						)}
					</>
				</Form>
			) : (
				<Spin className="sp-center-spin" />
			)}
		</Drawer>
	);
};

Component.propTypes = {
	data: PropTypes.object,
	onUpdate: PropTypes.func.isRequired,
	options: PropTypes.object.isRequired,
};

export default Component;
